/**
 * EventLog.jsx - Shows exploration event history
 */

import React from 'react';
import { resources } from '../../../data/resources';

// Helper to get resource icon from canonical source
const getResourceIcon = (resourceId) => resources[resourceId]?.icon || '📦';

export function EventLog({
  eventLog,
  eventLogIndex,
  setEventLogIndex
}) {
  if (eventLog.length === 0) {
    return null;
  }

  const e = eventLog[eventLogIndex];
  if (!e) {
    return null;
  }

  return (
    <div className="wm-event-log">
      <div className="wm-event-log-header">
        <span>Log</span>
        {eventLog.length > 1 && (
          <div className="wm-event-nav">
            <button
              className="wm-event-nav-btn"
              onClick={() => setEventLogIndex(p => Math.min(p + 1, eventLog.length - 1))}
              disabled={eventLogIndex >= eventLog.length - 1}
            >
              &lt;
            </button>
            <span className="wm-event-nav-count">{eventLogIndex + 1}/{eventLog.length}</span>
            <button
              className="wm-event-nav-btn"
              onClick={() => setEventLogIndex(p => Math.max(p - 1, 0))}
              disabled={eventLogIndex <= 0}
            >
              &gt;
            </button>
          </div>
        )}
      </div>
      <div className={`wm-event-entry ${e.penalties ? 'bad' : ''} ${e.rewards ? 'good' : ''}`}>
        <div className="wm-event-biome">
          <span className="wm-event-icon">{e.biomeIcon}</span>
          <span className="wm-event-biome-name">{e.biomeName}</span>
        </div>
        <div className="wm-event-text">{e.text}</div>
        {(e.rewards || e.penalties) && (
          <div className="wm-event-effects">
            {e.rewards && Object.entries(e.rewards).map(([r, a]) => (
              <span key={r} className="wm-event-reward">+{a} {getResourceIcon(r)}{r}</span>
            ))}
            {e.penalties && Object.entries(e.penalties).map(([r, a]) => (
              <span key={r} className="wm-event-penalty">-{a} {getResourceIcon(r)}{r}</span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default EventLog;
